import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useParams, useSearchParams } from 'react-router-dom';
import { OfferType } from '../../../types/enum/offersType';
import OfferListTable from '../../../components/store/offers/OfferListTable';
import { useStoreOffers } from '../../../hooks/store/offers';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import Pagination from '../../../components/ui/Pagination';
import EmptyData from '../../../components/ui/EmptyData';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { PermissionsKey } from '../../../data/permissions';

function StoreOffersOverView() {
      const { storeId} = useParams<{ storeId: string}>();
      const numericStoreId = storeId ? parseInt(storeId) : undefined;

          const {t} = useTranslation();
          const [searchParams,setSearchParams] = useSearchParams();
          const pageQuery = Number(searchParams.get('page')) || 1;
          const category = (searchParams.get("category")) ||""
    
          const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };

        const categories = [
          { id: OfferType.FIXED, name: t(OfferType.FIXED) },
          { id: OfferType.PERCENTAGE, name: t(OfferType.PERCENTAGE) },
          { id: OfferType.INCENTIVE, name: t(OfferType.INCENTIVE) },
        ];

        const {data:offers , isLoading, isError} = useStoreOffers({page:pageQuery,type:category||"",storeId:numericStoreId});

        const adminPermissions = useSelector((s:RootState)=>s.admin.permissions);
        const store = useSelector((s:RootState)=>s.store);

  return (
    <Layout title={t("layout_titles.offers")} headline={t('offers_headline',{num:offers?.offers.length})}>
        <CategoriesSection
        selectedCategory={category?category:""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={"add-offer"}
        buttonLabel='add_new_offer'
        showAdd={false}
        notShowAddButton={store?false:!adminPermissions.includes(PermissionsKey.CreateOffer)}
      />
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {offers && 
      (
        offers.offers.length===0 
        ?
        <EmptyData/>
        :
      <>
      <OfferListTable offers={offers?.offers} storeId={numericStoreId}/>
      <Pagination
      handlePagination={handlePagination}
      totalPages={offers.totalPages}
      currentPage={pageQuery}
      />
      </>
      )
      }
    </Layout>
  )
}

export default StoreOffersOverView